const PENDING_CONVERSION_KEY = 'pendingConversion';

// Conversion runs asynchronously after submit and the app has no backend
// signal for it. localStorage, not sessionStorage, so the flag survives a
// lead closing the app and coming back. The TTL caps how long a stuck
// conversion keeps the lead on the loading screen. The backend stops
// requesting the conversion after about 30 s (Customer.requestAutoConvert in
// web-app-alpha); the rest of the margin is for the unmeasured Salesforce
// conversion and sync back.
export const PENDING_CONVERSION_TTL_MS = 10 * 60 * 1000;

export const markConversionPending = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PENDING_CONVERSION_KEY, String(Date.now()));
  } catch {}
};

export const clearPendingConversion = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(PENDING_CONVERSION_KEY);
  } catch {}
};

export const isConversionPending = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem(PENDING_CONVERSION_KEY);
    if (!raw) return false;
    // A value that is not a number gives NaN, which fails the comparison.
    if (Date.now() - Number(raw) < PENDING_CONVERSION_TTL_MS) return true;
    window.localStorage.removeItem(PENDING_CONVERSION_KEY);
    return false;
  } catch {
    return false;
  }
};
